var map = {
	"./about.svg": "44b5",
	"./center.svg": "18fd",
	"./delete.svg": "d016",
	"./filter.svg": "f000",
	"./fit.svg": "242b",
	"./focus.svg": "605c",
	"./help.svg": "6023",
	"./info.svg": "28c7",
	"./insert.svg": "627a",
	"./invert.svg": "5b4a",
	"./lockpan.svg": "1cc9",
	"./lockzoom.svg": "59b1",
	"./move.svg": "6576",
	"./pan.svg": "77d3",
	"./scale.svg": "2512",
	"./variation.svg": "1441"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "769c";